import * as angular from "angular";
import * as _ from "lodash";
import {CancellationReasonVisibilitiesType} from "../types/cancellationReasonVisibilities.type";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {SiteContextService} from "../../commons/services/site-context.service";
import {CommonsService} from "../../commons/services/commons-service.service";
import {CancellationReasonType} from "../types/cancellation-reason.type";
import {ActionReasonVisibilityEnum} from "../../action-reasons/enums/action-reason-visibility.enum";
import {ActionReasonEnum} from "../../action-reasons/enums/action-reason.enum";
import {ActionReasonModel} from "../../action-reasons/models/action-reason.model";

export class CancellationReasonsDialogsService {

  servicesRef: any;

  /* @ngInject */
  constructor(private $mdDialog, private $filter, private commonsConstants, private $delivery, private siteContextService: SiteContextService) {
    this.servicesRef = this.$delivery();
  }

  createCancellationReason(actions, typeToCancel: CancellationReasonType, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-cancellation-reason.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.title = 'Add';
        $scope.cancellationReasonTypes = CancellationReasonType;
        $scope.actionsOptions = angular.copy(actions);
        $scope.cancellationReason = {
          reason: undefined,
          actions: [],
          description: undefined,
          typeToCancel: typeToCancel
        }

        $scope.consoleEnabled = true;
        $scope.agentAppEnabled = typeToCancel !== CancellationReasonType.Order;

        $scope.cancel = self.$mdDialog.cancel;

        //////////
        $scope.toggleAgentAppAvailability = (agentAppEnabled) => {
          $scope.agentAppEnabled = agentAppEnabled;
          if (!$scope.consoleEnabled && !$scope.agentAppEnabled) {
            $scope.consoleEnabled = true;
          }
        }

        $scope.toggleConsoleAvailability = (consoleEnabled) => {
          $scope.consoleEnabled = consoleEnabled;
          if (!$scope.consoleEnabled && !$scope.agentAppEnabled) {
            $scope.agentAppEnabled = true;
          }
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const cancellationReasonVisibilitiesList = [];
              if ($scope.agentAppEnabled && $scope.cancellationReason.typeToCancel !== $scope.cancellationReasonTypes.Order) {
                cancellationReasonVisibilitiesList.push(CancellationReasonVisibilitiesType.Agent);
              }
              if ($scope.consoleEnabled) {
                cancellationReasonVisibilitiesList.push(CancellationReasonVisibilitiesType.Admin);
              }
              _.set($scope.cancellationReason, 'cancellationReasonVisibilities', cancellationReasonVisibilitiesList);
              self.$mdDialog.hide($scope.cancellationReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  updateCancellationReason(actions, cancellationReason, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-cancellation-reason.html').default,
      controller: function ($scope) {
        $scope.cancel = self.$mdDialog.cancel;

        $scope.title = 'Edit'
        $scope.actionsOptions = angular.copy(actions);
        $scope.cancellationReasonTypes = CancellationReasonType;
        $scope.cancellationReason = angular.copy(cancellationReason);
        $scope.cancellationReasonVisibilitiesType = CancellationReasonVisibilitiesType

        $scope.cancellationReasonVisibilitiesList = _.get($scope.cancellationReason, 'cancellationReasonVisibilities', []);
        $scope.agentAppEnabled = !!_.find($scope.cancellationReasonVisibilitiesList, (crv) => {
          return crv === CancellationReasonVisibilitiesType.Agent
        });
        $scope.consoleEnabled = !!_.find($scope.cancellationReasonVisibilitiesList, (crv) => {
          return crv === CancellationReasonVisibilitiesType.Admin
        })

        //setting the actionsOptions Mandatory fields as the cancellationReason mandatory fields
        _.forEach($scope.cancellationReason.actions, (chosenAction) => {

          let actionOptions = _.find($scope.actionsOptions, (actionOption) => {
            return actionOption.type === chosenAction.type;
          })

          if (actionOptions.mandatory)
            actionOptions.mandatory = chosenAction.mandatory;
        })

        $scope.onActionsChange = (actions) => {
          $scope.cancellationReason.actions = actions;
        }

        $scope.toggleAgentAppAvailability = (agentAppEnabled) => {
          $scope.agentAppEnabled = agentAppEnabled;
          if (!$scope.consoleEnabled && !$scope.agentAppEnabled) {
            $scope.consoleEnabled = true;
          }
        }

        $scope.toggleConsoleAvailability = (consoleEnabled) => {
          $scope.consoleEnabled = consoleEnabled;
          if (!$scope.consoleEnabled && !$scope.agentAppEnabled) {
            $scope.agentAppEnabled = true;
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.cancellationReasonVisibilitiesList = [];
              if ($scope.agentAppEnabled && $scope.cancellationReason.typeToCancel !== $scope.cancellationReasonTypes.Order) {
                $scope.cancellationReasonVisibilitiesList.push(CancellationReasonVisibilitiesType.Agent);
              }
              if ($scope.consoleEnabled) {
                $scope.cancellationReasonVisibilitiesList.push(CancellationReasonVisibilitiesType.Admin);
              }
              _.set($scope.cancellationReason, 'cancellationReasonVisibilities', $scope.cancellationReasonVisibilitiesList);
              self.$mdDialog.hide($scope.cancellationReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  createCancelTaskReason(serviceIds, event?, includeRemoveCheckbox?, header?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/cancel-task-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia, deliveriesService: DeliveriesService) {

        $scope.isCancellationCommentMandatory = self.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;
        $scope.header = header;
        $scope.selectedServices = undefined;
        $scope.cancelableServices = undefined;
        $scope.unCancelableServices = undefined;
        $scope.cancelRelatedChecked = undefined;
        $scope.isRouted;
        $scope.cancellationReasonVisibilitiesType = CancellationReasonVisibilitiesType;
        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;

        $scope.isMobile = !$mdMedia('gt-md');

        $scope.calcRouted = () => {
          $scope.isRouted = false;
          let totalServices = $scope.selectedServices;
          if ($scope.cancelRelatedChecked) {
            totalServices = _.union($scope.selectedServices, $scope.cancelableServices)
          }
          _.forEach(totalServices, service => {
            if (service.routeId) {
              $scope.isRouted = true;
              return;
            }
          })

        };


        self.servicesRef.$asyncValues(serviceIds)
          .then((services) => {
            $scope.selectedServices = services;
            $scope.cancellationReasonTypes = _.uniq(_.map(services, 'serviceType'));
            const relatedServiceIds = deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
            return self.servicesRef.$asyncValues(relatedServiceIds)
          })
          .then((relatedServices) => {

            const cancelableServices = relatedServices.filter((relatedService) => {
              return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
            });

            const unCancelableServices = _.differenceBy(relatedServices, cancelableServices);

            $scope.cancelableServices = angular.copy(cancelableServices);
            $scope.unCancelableServices = angular.copy(unCancelableServices);

            $scope.cancelRelatedChecked = !!$scope.cancelableServices?.length;

            $scope.calcRouted();

          });

        $scope.includeRemoveCheckbox = includeRemoveCheckbox;
        $scope.selectedCancellationReason = undefined;

        $scope.cancelTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          serviceType: undefined,
          removeFromRoute: true
        }

        $scope.onCancelableServicesToggled = () => {
          $scope.cancelRelatedChecked = !$scope.cancelRelatedChecked;
          $scope.calcRouted();
        }

        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) return;
          $scope.selectedCancellationReason = cancellationReason;
          $scope.cancelTaskReason.reason = cancellationReason.reason;
          $scope.cancelTaskReason.externalId = cancellationReason.externalId;
          $scope.cancelTaskReason.description = cancellationReason.description;
          $scope.cancelTaskReason.actions = cancellationReason.actions;
          $scope.cancelTaskReason.typeToCancel = cancellationReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              let cancelableServicesIds = [];
              if ($scope.cancelRelatedChecked) {
                cancelableServicesIds = _.map($scope.cancelableServices, (s) => {
                  return s.id
                })
              }

              self.$mdDialog.hide({
                cancelReason: $scope.cancelTaskReason,
                relatedServicesIds: cancelableServicesIds
              });
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  createThreeplServiceCancelReason(serviceIds, event?, header?, isShowAttachment?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/threepl-service-cancel-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia) {

        $scope.isCancellationCommentMandatory = self.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;
        $scope.header = header;
        $scope.selectedServices = undefined;
        $scope.cancelableServices = undefined;
        $scope.unCancelableServices = undefined;
        $scope.cancelRelatedChecked = undefined;
        $scope.isRouted;
        $scope.cancellationReasonVisibilitiesType = CancellationReasonVisibilitiesType;
        $scope.isShowAttachment = isShowAttachment;

        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;

        $scope.isMobile = !$mdMedia('gt-md');
        $scope.cancellationReasonTypes = [CancellationReasonType.Delivery];

        $scope.selectedCancellationReason = undefined;

        $scope.cancelTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          serviceType: undefined,
          removeFromRoute: true
        }


        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) return;
          $scope.selectedCancellationReason = cancellationReason;
          $scope.cancelTaskReason.reason = cancellationReason.reason;
          $scope.cancelTaskReason.externalId = cancellationReason.externalId;
          $scope.cancelTaskReason.description = cancellationReason.description;
          $scope.cancelTaskReason.actions = cancellationReason.actions;
          $scope.cancelTaskReason.typeToCancel = cancellationReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              let cancelableServicesIds = [];
              if ($scope.isService && $scope.cancelRelatedChecked) {
                cancelableServicesIds = _.map($scope.cancelableServices, (s) => {
                  return s.id
                })
              }

              self.$mdDialog.hide({
                cancelReason: $scope.cancelTaskReason,
                relatedServicesIds: cancelableServicesIds
              });
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  changeToBackInStore(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/back-in-store.html').default,
      controller: function ($scope, commonsService: CommonsService, $log) {

        $scope.backInStoreReason = {
          title: self.$filter('translate')('Back in Store'),
          text: self.$filter('translate')('The package is back in store'),
          attachments: []
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.backInStoreReason.attachments.push(attachment);
          }
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.backInStoreReason.attachments.splice(index, 1);
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.backInStoreReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

}

angular
  .module('bringoz.admin.cancellation-reasons')
  .service('cancellationReasonsDialogsService', CancellationReasonsDialogsService);
